export default __webpack_public_path__ + "static/media/hoangnguyen.9076000b.png";